import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import ListState from '../../components/LedgerAndCashbook/TransporterFreightReport'
import constant from '../../constant'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { v2_ledger_transporter_report } from '../../actions/v2/ledgerAndCashbook'
import moment from 'moment'
import { v2_companies } from '../../actions/v2/company'
import { validateFunctionalForm } from '../../utils'
import { v2_transporter_vehicles, v2_transporters } from '../../actions/v2/transporter'
import { v3_update_ledger_transporter_report } from '../../actions/v3/ledgerAndCashbook'
const List = (props) => {

    // State and useEffect hooks
    const location = useLocation();
    const { page } = location.state || {};
    const [data, setData] = useState(null);
    const [currentPage, setCurrentPage] = useState(page ? page : 1);
    const [limit, setLimit] = useState(10);
    const [searchModel, setSearchModel] = useState({
        startDate: '',
        endDate: '',
        transporter: '',
        vehicle: '',
    });

    useEffect(() => {
        if (searchModel.transporter) {
            v2_ledger_transporter_report(searchModel, currentPage, limit).then((res) => {
                if (res.status) {
                    setData(res.result);
                    props.history.push(constant.Authedcomponent.transportFreightReport.url, {
                        page: currentPage,
                    });
                } else {
                    toast.error(res.error);
                }
            });
        }
    }, [currentPage, limit, searchModel.startDate, searchModel.endDate, searchModel.transporter]);

    useEffect(() => {
        if (searchModel.startDate && searchModel.endDate) {
            setCurrentPage(1);
            v2_ledger_transporter_report(searchModel, 1, limit).then((res) => {
                if (res.status) {
                    setData(res.result);
                    props.history.push(constant.Authedcomponent.transportFreightReport.url, {
                        page: currentPage,
                    });
                } else {
                    toast.error(res.error);
                }
            });
        }
    }, [searchModel, limit]);

    return (

        <div className="page-content">
            <div className="container-fluid">
                {/* start page title */}
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                            <h4 className="mb-sm-0 font-size-18">Transport Freight Report</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">DashBoard</a>
                                    </li>
                                    <li className="breadcrumb-item active">Report Management</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* end page title */}

                <div className="row">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-body">
                                <SearchOptions onSubmit={setSearchModel}
                                    data={data}
                                    limit={limit}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-body">
                                {data && (
                                    <ListState
                                        limit={limit}
                                        data={data}
                                        currentPage={currentPage}
                                        setCurrentPage={setCurrentPage}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default List

const SearchOptions = (props) => {
    const [state, setState] = useState({
        startDate: { name: 'startDate', value: '', isRequired: false, error: '' },
        endDate: { name: 'endDate', value: '', isRequired: false, error: '' },
        transporter: { name: 'transporter', value: '', options: [], isRequired: true, error: '' },
        vehicle: { name: 'vehicle', value: '', options: [], isRequired: false, error: '' },

    });

    const [records, setRecords] = useState([]);
    const [transporterDetails, setTransporterDetails] = useState(null);
    const [carryForward, setCarryForward] = useState({ creditTotal: 0, debitTotal: 0 });
    const [loading, setLoading] = useState(false);

    const updateRecord = async () => {
        if (validateFunctionalForm(state, setState)) {
            const model = {
                startDate: state.startDate.value,
                endDate: state.endDate.value,
                transporter: state.transporter.value,
                vehicle: state.vehicle.value,
            };

            v3_update_ledger_transporter_report(model).then((res) => {
                if (res.status) {
                    toast.success('Report Updated Successfully');
                }
                else {
                    toast.error(res.error)
                }
            })
        }
        else {
            toast.error()
        }
    }

    const fetchAllRecord = async () => {
        if (validateFunctionalForm(state, setState)) {
            const model = {
                startDate: state.startDate.value,
                endDate: state.endDate.value,
                transporter: state.transporter.value,
                vehicle: state.vehicle.value,
            };

            let currentPage = 1;
            let allLedgers = [];
            let totalPages = 1;

            setLoading(true); // Start loading

            try {
                while (currentPage <= totalPages) {
                    const response = await v2_ledger_transporter_report(model, currentPage, props.limit);

                    // Ensure ledgers exists and is an array
                    const ledgers = Array.isArray(response.result.ledgers) ? response.result.ledgers : [];
                    let { totalPages: totalPages, transporterDetails: transporterDetail } = response.result;

                    if (currentPage === 1) {
                        setTransporterDetails(transporterDetail);
                    }

                    // Append current page ledgers to allLedgers
                    allLedgers = [...allLedgers, ...ledgers];
                    totalPages = totalPages || 1;

                    currentPage++;
                }
                // Calculate balance and add it to each ledger
                let currentBalance = 0; // Initialize balance
                allLedgers = allLedgers.map((item) => {
                    if (item.PAYMENT_TYPE === 'CREDIT') {
                        currentBalance += item.AMOUNT; // Increase balance for credit
                    } else if (item.PAYMENT_TYPE === 'DEBIT') {
                        currentBalance -= item.AMOUNT; // Decrease balance for debit
                    }
                    return { ...item, balance: currentBalance }; // Add balance to the item
                });

                setRecords(allLedgers); // Set the records with calculated balances

            } catch (error) {
                console.error('Error fetching records:', error);
            } finally {
                setLoading(false); // End loading
            }
        }
    };


    const fetchTransporters = async () => {
        const res = await v2_transporters();
        if (res.status) {
            setState(prevState => ({
                ...prevState,
                transporter: { ...prevState.transporter, options: res.result }
            }));
        }
    };
    const fetchVehicle = async () => {
        const res = await v2_transporter_vehicles(state.transporter.value);
        if (res.status) {
            setState(prevState => ({
                ...prevState,
                vehicle: { ...prevState.vehicle, options: res.result, value: '' }
            }));
        }
    };
    useEffect(() => {

        fetchTransporters();


    }, []);
    useEffect(() => {
        debugger
        if (state.transporter.value) {
            fetchVehicle();
        }
        else {
            setState(prevState => ({
                ...prevState,
                vehicle: { ...prevState.vehicle, options: [], value: '' }
            }));
        }

    }, [state.transporter.value]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: { ...prevState[name], value }
        }));
    };

    const handleSearch = () => {
        if (validateFunctionalForm(state, setState)) {
            const model = {
                startDate: state.startDate.value,
                endDate: state.endDate.value,
                transporter: state.transporter.value,
                vehicle: state.vehicle.value,

            };
            props.onSubmit(model);
        }
    };

    const handleReset = () => {
        setState({
            startDate: { name: 'startDate', value: '', isRequired: false, error: '' },
            endDate: { name: 'endDate', value: '', isRequired: false, error: '' },
            transporter: { name: 'transporter', value: '', options: [], isRequired: false, error: '' },
            vehicle: { name: 'transporter', value: '', options: [], isRequired: false, error: '' },
        });
        setRecords([]); // Clear records on reset
        setTransporterDetails(null); // Clear party details on reset
    };

    const handlePrint = () => {
        const contentToPrint = document.getElementById("ledgerPrintSection").innerHTML;
        const printWindow = window.open('', '_blank', 'width=800,height=600');
        printWindow.document.write(`
            <html>
                <head>
                    <title>Print Ledger</title>
                    <style>
                        body { font-family: Arial, sans-serif; }
                        .text-center { text-align: center; }
                        .text-end { text-align: right; }
                        table { width: 100%; border-collapse: collapse; }
                        th, td { border: 1px solid #000; padding: 8px; text-align: left; }
                    </style>
                </head>
                <body>
                    ${contentToPrint}
                </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    };

    return (
        <React.Fragment>
            <form className="row gy-12 gx-12 align-items-center">
                <div className={state.vehicle.options.length > 0 ? "col-sm-2 mb-2" : "col-sm-4 mb-2"}>
                    <label htmlFor="companySelect">Transporter</label>
                    <div className="input-group">
                        <select
                            id="companySelect"
                            name="transporter"
                            className={state.transporter.error && !state.transporter.value ? "form-select is-invalid" : "form-select"}
                            value={state.transporter.value}
                            onChange={handleChange}
                        >
                            <option value="">Select Transporter</option>
                            {state.transporter.options.map(option => (
                                <option key={option.ID} value={option.ID}>{option.NAME}</option>
                            ))}
                        </select>
                    </div>
                </div>
                {state.vehicle.options.length > 0 && <div className="col-sm-2 mb-2">
                    <label htmlFor="vehicleSelect">Vehicle</label>
                    <div className="input-group">
                        <select
                            id="vehicleSelect"
                            name="party"
                            className={state.vehicle.error && !state.vehicle.value ? "form-select is-invalid" : "form-select"}
                            value={state.vehicle.value}
                            onChange={handleChange}
                        >
                            <option value="">Select Vehicle</option>
                            {state.vehicle.options.map(option => (
                                <option key={option.ID} value={option.ID}> {option.VEHICLE_NUMBER} - {option.NAME}</option>
                            ))}
                        </select>
                    </div>
                </div>}

                {/* Date Range */}
                <div className="col-sm-4 mb-2">
                    <label>Date Range</label>
                    <div className="row">
                        <div className="col">
                            <div className="input-group">
                                <input
                                    type="date"
                                    id="startDate"
                                    name="startDate"
                                    className="form-control"
                                    value={state.startDate.value}
                                    onChange={handleChange}
                                    placeholder="From"
                                />
                            </div>
                        </div>
                        <div className="col">
                            <div className="input-group">
                                <input
                                    type="date"
                                    id="endDate"
                                    name="endDate"
                                    className="form-control"
                                    value={state.endDate.value}
                                    onChange={handleChange}
                                    placeholder="To"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Buttons */}
                <div className="col-sm-4 mb-2 d-flex align-items-center" style={{ top: '14px' }}>
                    <button
                        type="button"
                        className="btn btn-success waves-effect btn-label waves-light me-2"
                        onClick={handleSearch}
                    >
                        <i className="bx bx-search label-icon" /> Search
                    </button>
                    <button
                        type="button"
                        className="btn btn-outline-danger me-2"
                        onClick={handleReset}
                    >
                        <i className="bx bx-reset label-icon" />
                        Reset
                    </button>
                    <button
                        type="button"
                        className="btn btn-outline-info me-1"
                        data-bs-toggle="modal"
                        data-bs-target="#staticBackdrop4"
                        onClick={fetchAllRecord} // Fetch records before showing modal
                    >
                        <i className="bx bx-show label-icon" /> View
                    </button>

                    <button
                        type="button"
                        className="btn btn-outline-info me-1"
                        onClick={updateRecord} // Fetch records before showing modal
                    >
                        <i className="mdi mdi-cloud-refresh label-icon" /> Update
                    </button>

                    {/* STATIC BACKDROP MODAL */}
                    <div
                        className="modal fade"
                        id="staticBackdrop4"
                        data-bs-backdrop="static"
                        data-bs-keyboard="false"
                        tabIndex={-1}
                        role="dialog"
                        aria-labelledby="staticBackdropLabel"
                        aria-hidden="true"
                    >
                        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                            <div className="modal-content" id="ledgerPrintSection">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="staticBackdropLabel">
                                        {transporterDetails ? transporterDetails.TRANSPORTER_NAME : 'Loading...'}
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    />
                                </div>
                                <div className="modal-body">
                                    {/* Replace hard-coded details with dynamic data */}
                                    {transporterDetails && (
                                        <>
                                            <div className="ledger-header text-center">
                                                <h5>Transporter: {transporterDetails.TRANSPORTER_NAME}</h5>
                                                {transporterDetails.EMAIL && <p>Email: {transporterDetails.EMAIL}</p>}
                                                <p>Contact: {transporterDetails.PHONE}</p>
                                            </div>

                                            <div className="ledger-period">
                                                <p className="text-center">
                                                    {state.startDate.value
                                                        ? moment(state.startDate.value).format('DD MMM YYYY')
                                                        : ''}
                                                    {state.startDate.value && state.endDate.value ? ' to ' : ''}
                                                    {state.endDate.value
                                                        ? moment(state.endDate.value).format('DD MMM YYYY')
                                                        : ''}
                                                </p>
                                                <p>Page 1</p>
                                            </div>

                                            <table className="table table-striped mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Date</th>
                                                        <th></th>
                                                        <th>Particulars</th>
                                                        <th>Vch No.</th>
                                                        <th>Credit</th>
                                                        <th>Debit</th>
                                                        <th>Balance</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {records.map((record, index) => {
                                                        return (<tr key={index}>
                                                            <td>{record.DATE}</td>
                                                            <td>{record.PAYMENT_TYPE === 'CREDIT' ? 'Cr ' : 'Dr '}</td>
                                                            <td>{record.TITLE}</td>
                                                            <td>{record.INVOICE_NUMBER || 'Receipt'}</td>
                                                            <td>{record.PAYMENT_TYPE === 'CREDIT' ? record.AMOUNT.toLocaleString() : ''}</td>
                                                            <td>{record.PAYMENT_TYPE === 'DEBIT' ? record.AMOUNT.toLocaleString() : ''}</td>
                                                            <td>{record.balance}</td>
                                                        </tr>)
                                                    }

                                                    )}
                                                </tbody>
                                            </table>

                                        </>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                    <button type="button" className="btn btn-primary" onClick={handlePrint}>Download</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <div className="row align-items-center justify-content-start mt-3">
                {/* Total Credit */}
                <div className="col-3">
                    <StatsCard title="Total Credit" value={props?.data?.balancePayment?.CREDIT_SUM} />
                </div>

                {/* Minus Sign */}
                <div className="col-1">
                    <span className="fw-semibold fs-4">-</span>
                </div>

                {/* Total Debit */}
                <div className="col-3">
                    <StatsCard title="Total Debit" value={props?.data?.balancePayment?.DEBIT_SUM} />
                </div>

                {/* Equals Sign */}
                <div className="col-1">
                    <span className="fw-semibold fs-4">=</span>
                </div>

                {/* Total Balance Remaining */}
                <div className="col-4">
                    <StatsCard
                        title="Total Balance Remaining"
                        value={props?.data?.balancePayment?.CREDIT_SUM - props?.data?.balancePayment?.DEBIT_SUM}
                    />
                </div>
            </div>



        </React.Fragment >

    );
};


const StatsCard = ({ title, value }) => (
    <div className="col-12">
        <div className="card mini-stats-wid bg-secondary">
            <div className="card-body">
                <div className="d-flex">
                    <div className="flex-grow-1">
                        <p className="text-white fw-semibold">{title}</p>
                        <h4 className="text-white mb-0">{value || 0}</h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
);
